export function toggleAutoRedirectMode() {
  const autoRedirectMode = getAutoRedirectMode();
  const newValue = autoRedirectMode ? 'false' : 'true';
  window.localStorage.setItem('autoRedirectMode', newValue);
  return newValue;
}

export function getAutoRedirectMode(): boolean {
  const value = window.localStorage.getItem('autoRedirectMode');

  if (value === undefined || value === null) {
    window.localStorage.setItem('autoRedirectMode', 'true');
    return true;
  }

  return value === 'true';
}

export function getAutoRedirectPath() {
  return window.localStorage.getItem('autoRedirectPath');
}

export function setAutoRedirectPath(url) {
  window.localStorage.setItem('autoRedirectPath', url);
}
